import { createLazyComponent } from '@muse-web/router'

import { OtherCreatorsSkeleton } from '../components/other-creators'

import { type TListenNextContainerProps } from './ListenNextContainer'

const loadListenNext = () =>
    import(/* webpackChunkName: 'audio-suggestions' */ './ListenNextContainer')

const ListenNextFallback = ({ title, audios }: TListenNextContainerProps) => (
    <OtherCreatorsSkeleton title={title} count={audios.length} />
)

export const AsyncListenNextContainer = createLazyComponent(loadListenNext, 'ListenNextContainer', {
    keepServerMarkup: true,
    fallback: ListenNextFallback,
})
